<div class="content">
    <div class="content-header">
        <p>{{ 'pages.userRecords.card.requestDetailsDialog.userInfo' | translate }}</p>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    </div>

    <div *ngIf="!loading">
        <div class="user-bcitiCard">
            <div class="cardType-block" [ngClass]="data.card.cardType">
                <span>
                    <i [ngClass]="cardIcon"></i>
                    {{ cardLabel }}
                </span>
            </div>
            <div class="user-infos">
                <div class="avatar-block">
                    <img class="user-avatar" [src]="data.card.renewal?.photo || data.card.photo" alt="demo-avatar">
                    <span class="user-name">
                        <span>
                            {{ data.card.renewal?.firstName || data.card.firstName }} {{ data.card.renewal?.lastName || data.card.lastName }}
                        </span>
                    </span>
                </div>
                <div class="infos-block">
                    <p>
                        <span class="label">{{ 'common.fields.sex' | translate }}: </span>
                        <span *ngIf="!data.card.renewal?.sex">{{ 'common.' + (data.card.sex || data.user.sex) | translate }}</span>
                        <span *ngIf="data.card.renewal?.sex">{{ 'common.' + (data.card.renewal.sex || data.user.sex) | translate }}</span>
                    </p>
                    <p>
                        <span class="label">{{ 'common.fields.birthdate' | translate }}: </span>
                        <span *ngIf="!data.card.renewal?.birthDate">{{ formatDate(data.card.birthDate || data.user.birthDate) }}</span>
                        <span *ngIf="data.card.renewal?.birthDate">{{ formatDate(data.card.renewal.birthDate || data.user.birthDate) }}</span>
                    </p>
                    <p>
                        <span class="label">{{ 'common.fields.address-short' | translate }}: </span>
                        <span>
                            <span *ngIf="data.card.address.unit || data.card.renewal?.address?.unit">
                                {{ data.card.renewal?.address?.unit || data.card.address.unit }}
                            </span>
                            {{ data.card.renewal?.address?.number || data.card.address.number }}
                            {{ data.card.renewal?.address?.streetName || data.card.address.streetName }}, 
                            {{ data.card.renewal?.address?.city || data.card.address.city }},
                        </span>
                        <span>
                            {{ data.card.renewal?.address?.province || data.card.address.province }}, 
                            {{ data.card.renewal?.address?.postCode || data.card.address.postCode}}
                        </span>
                    </p>
                    <p *ngIf="data.action != CardAction.SUBSCRIBE">
                        <span class="label">{{ 'common.fields.cardCode' | translate }}: </span>
                        <span *ngIf="!data.card.renewal?.number">{{ data.card.number }}</span>
                        <span *ngIf="data.card.renewal?.number">{{ data.card.renewal.number }}</span>
                    </p>
                    <p>
                        <span *ngIf="backgroundCheck.backgroundCheck" class="backgroundCheck">
                            <span class="icon-warning"></span>
                            {{ 'pages.userRecords.card.requestDetailsDialog.backgroundCheck' | translate }}
                        </span>
                    </p>
                    <div *ngIf="subTypes?.length > 0">
                        <form [formGroup]="requestCardForm">
                                <app-form-select *ngIf="subTypes.length > 0" 
                                    [options]="subTypes" 
                                    formControlName="subType"
                                    [required]="true" 
                                    [invalid]="!requestCardForm?.valid && isSubmitted"
                                    label="{{ 'pages.userRecords.card.requestDetailsDialog.subTypes.label' | translate }}"
                                    [placeholder]="'pages.userRecords.card.requestDetailsDialog.subTypes.label' | translate"
                                >
                                    <app-form-error *ngIf="!requestCardForm?.valid && isSubmitted">
                                        {{ 'pages.userRecords.card.requestDetailsDialog.message.approve.errorStatus' | translate }}
                                    </app-form-error>
                                </app-form-select>
                            </form>
                            <form [formGroup]="form">
                                <div class="form" *ngIf="data.action == CardAction.SUBSCRIBE" >
                                    <app-form-input
                                        class="select"
                                        [invalidPass] = "invalidCardNumber"
                                        label="{{ 'pages.user-cards.family.common.fields.citizenCardNumber.placeholder' | translate }}"
                                        placeholder="{{ 'pages.user-cards.family.common.fields.citizenCardNumber.placeholder' | translate }}"
                                        formControlName="cardNumber"
                                        invalidText = "{{ 'pages.user-cards.update.errors.numberRequired' | translate }}"
                                        [messages]="true"
                                    >
                                    </app-form-input>
                                </div>
                                <div class="form">
                                    <app-form-datepicker *ngIf="!hideExpDate" 
                                        class="text-input" 
                                        [invalidPass] = "invalidExpDate"
                                        label="{{ 'pages.user-cards.update.expDate' | translate }}" 
                                        formControlName="expDate" 
                                        [min]="tomorrow" 
                                        data-cy="expDate"
                                        >
                                        <app-form-error *ngIf="isSubmitted && !form.controls['expDate'].valid">
                                            {{ 'pages.user-cards.update.errors.expDateRequired' | translate }}
                                        </app-form-error>
                                    </app-form-datepicker>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <h4 class="files-header">{{ 'pages.userRecords.card.requestDetailsDialog.attachments' | translate }}</h4>

        <div class="files-container" *ngIf="data.card?.proofOfIdentity?.length > 0">
            <div *ngFor="let url of data.card.proofOfIdentity; let i = index"
                class="file" 
                (click)="viewDocument(url)"
                [ngStyle]="urlIsImage(url) ? {'background-image': 'url(' + url +')'} : ''"
            >
                <span *ngIf="!urlIsImage(url)" class="pdf-file-icon icon-office-file-pdf"></span>
            </div>
        </div>
        <div class="files-container" *ngIf="data.card?.renewal?.proofOfIdentity?.length > 0 && data.action === CardAction.RENEW">
            <div *ngFor="let url of data.card.renewal.proofOfIdentity; let i = index" 
                class="file"
                (click)="viewDocument(url)" 
                [ngStyle]="urlIsImage(url) ? {'background-image': 'url(' + url +')'} : ''"
            >
                <span *ngIf="!urlIsImage(url)" class="pdf-file-icon icon-office-file-pdf"></span>
            </div>
        </div>
    </div>

</div>

<footer>
    <div *ngIf="!!discrepancies">
        <div class="row">
            <div class="col">
                <span class="icon-warning"></span>
            </div>
            <div class="text-warning">
                <span>{{ discrepancies.message}}</span>
            </div>
        </div>
        <mat-list>
            <mat-list-item *ngFor="let user of discrepancies.users">
                {{ user.firstName }} - {{ user.lastName }} - {{ user.cardNumber }}
            </mat-list-item>
        </mat-list>       
    </div>
    <ng-container *ngIf='!loading'>
        <button [disabled]="denyLoading || approveLoading" class="bciti-button bciti-button--red" (click)="handleDeny()">
            <span *ngIf="!denyLoading">{{ 'pages.userRecords.card.requestDetailsDialog.button.deny' | translate }}</span>
            <mat-spinner *ngIf="denyLoading" diameter="20"></mat-spinner>
        </button>
        <button [disabled]="denyLoading || approveLoading" class="bciti-button bciti-button--blue"
        (click)="handleApprove()">
            <span
            *ngIf="!approveLoading">{{ 'pages.userRecords.card.requestDetailsDialog.button.approve' | translate }}</span>
            <mat-spinner *ngIf="approveLoading" diameter="20"></mat-spinner>
        </button>
    </ng-container>
  </footer>